function csrfToken() {
  return document.querySelector('meta[name="csrf-token"]')?.content || ''
}

export async function apiFetch(url, options = {}) {
  const res = await fetch(url, {
    credentials: 'same-origin',
    ...options,
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'X-CSRF-Token': csrfToken(),
      ...options.headers
    }
  })

  if (res.status === 401) {
    window.location.href = '/login'
    return null
  }
  if (res.status === 204) return null

  const data = await res.json()
  if (!res.ok) {
    const msg = Array.isArray(data.errors) ? data.errors.join(', ') : (data.error || `HTTP ${res.status}`)
    const error = new Error(msg)
    error.status = res.status
    throw error
  }
  return data
}

export function apiGet(path, params = {}) {
  const searchParams = new URLSearchParams()
  for (const [key, value] of Object.entries(params)) {
    if (value == null || value === '') continue
    if (Array.isArray(value)) {
      value.forEach(v => searchParams.append(`${key}[]`, v))
    } else {
      searchParams.append(key, value)
    }
  }
  const query = searchParams.toString()
  return apiFetch(query ? `${path}?${query}` : path)
}

export function apiPost(path, body = {}) {
  return apiFetch(path, { method: 'POST', body: JSON.stringify(body) })
}

export function apiPut(path, body = {}) {
  return apiFetch(path, { method: 'PUT', body: JSON.stringify(body) })
}

export function apiDelete(path) {
  return apiFetch(path, { method: 'DELETE' })
}
